module.exports = __webpack_public_path__ + "img/avg_score-icon.1bc5b4b4.svg";